var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMausfabLogo2021(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg918",
    viewBox: "0 0 72 12",
    height: "12mm",
    width: "72mm",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.999,
      fill: "#d50000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.265,
      strokeLinecap: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "fill markers stroke"
    },
    id: "rect876",
    width: 4.599997,
    height: 4.599997,
    x: -14.3568,
    y: 1.8274397,
    ry: 0.65264964,
    rx: 0.65264964,
    transform: "scale(-1,1)"
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fontSize: "11.2889px",
      lineHeight: 1.25,
      fontFamily: "JejuGothic",
      InkscapeFontSpecification: "JejuGothic",
      stroke: "#000000",
      strokeWidth: 0.465,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    x: 15.70743,
    y: 10.1116,
    id: "text886"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan884",
    x: 15.70743,
    y: 10.1116,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontFamily: "Mapo\uB2F9\uC778\uB9AC\uBC1C\uC804\uC18C",
      InkscapeFontSpecification: "Mapo\uB2F9\uC778\uB9AC\uBC1C\uC804\uC18C",
      stroke: "#000000",
      strokeWidth: 0.465,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }, "Mausfab")), /*#__PURE__*/React.createElement("rect", {
    transform: "scale(-1,1)",
    rx: 0.65264964,
    ry: 0.65264964,
    y: 6.427444,
    x: -9.756794,
    height: 4.599997,
    width: 4.599997,
    id: "rect854",
    style: {
      opacity: 0.999,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.265,
      strokeLinecap: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "fill markers stroke"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMausfabLogo2021);
export default __webpack_public_path__ + "static/media/mausfab_logo_2021.cbaf473f0effe13c37f583f340f15698.svg";
export { ForwardRef as ReactComponent };